import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChangePasswordCard } from './ChangePasswordCard';

const API = process.env.REACT_APP_BACKEND_URL;

// Change Password block for accounts that sign in with a password (hidden for Google-only accounts).
export const AccountPasswordSection = ({ token, onNewToken, className = '' }) => {
  const [hasPassword, setHasPassword] = useState(false);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/api/auth/my-security`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setHasPassword(r.data.has_password)).catch(() => {});
  }, [token]);
  if (!hasPassword) return null;
  return (
    <div className={className} data-testid="account-password-section">
      <ChangePasswordCard token={token} onNewToken={onNewToken} />
    </div>
  );
};
